"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicScoreDisplay = exports.NoReportWrapper = exports.Error = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const components_1 = require("../../components");
const bureaus_1 = require("../../utils/bureaus");
exports.Error = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ size: 'sm' })).withConfig({ displayName: "reports-Error", componentId: "reports-1so0p2h" }) `
  padding: 24px;
`;
const GetStartedLink = (0, styled_components_1.default)(base_react_components_1.Button).withConfig({ displayName: "reports-GetStartedLink", componentId: "reports-yrxgl4" }) `
  align-self: center;
  margin-bottom: 16px;
  margin-right: 16px;
`;
const InputWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-InputWrapper", componentId: "reports-1w4qmcm" }) `
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`;
const LoaderWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-LoaderWrapper", componentId: "reports-tna9t4" }) `
  grid-column: span 2;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const NoReportText = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ size: 'sm' })).withConfig({ displayName: "reports-NoReportText", componentId: "reports-12h6yf" }) `
  margin-bottom: 16px;
`;
exports.NoReportWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-NoReportWrapper", componentId: "reports-1lhanfs" }) `
  grid-row: span 3;
`;
const NotMyBusinessLink = (0, styled_components_1.default)(base_react_components_1.Button).attrs(() => ({
    variation: 'outline',
})).withConfig({ displayName: "reports-NotMyBusinessLink", componentId: "reports-1i3k1xy" }) `
  margin-bottom: 16px;
`;
/** TODO: Add REPORTS_BASE_URL to ent_web and pipsqueak */
const { REPORTS_BASE_URL } = (_a = process.env) !== null && _a !== void 0 ? _a : '/partner';
const BasicScoreDisplay = (_a) => {
    var _b;
    var { bureau = 'xpn', className, error, isLoading } = _a, _c = _a.report, _d = _c === void 0 ? {} : _c, { business } = _d, scoreDisplayProps = __rest(_d, ["business"]), { isDirect = false } = _a;
    const { displayName: bureauName, slug: bureauSlug } = (_b = (0, bureaus_1.getBureau)(bureau)) !== null && _b !== void 0 ? _b : {};
    const businessMatchLink = isDirect
        ? `/business-search-${bureauSlug}`
        : `${REPORTS_BASE_URL}/business-match/${bureauSlug}`;
    if (error) {
        return (react_1.default.createElement(exports.Error, { className: className },
            "Your score didn't load correctly - our bad. It could be because ", bureauName !== null && bureauName !== void 0 ? bureauName : 'a bureau',
            " didn't find your business, try",
            react_1.default.createElement(base_react_components_1.Link, { href: businessMatchLink }, " matching your business")));
    }
    if (isLoading) {
        return (react_1.default.createElement(LoaderWrapper, null,
            react_1.default.createElement(components_1.LoadingDots, null)));
    }
    if ((scoreDisplayProps === null || scoreDisplayProps === void 0 ? void 0 : scoreDisplayProps.riskCategory) === 'InsufficientData') {
        return (react_1.default.createElement(exports.NoReportWrapper, { className: className },
            react_1.default.createElement(components_1.NeedMoreInfoWarning, { title: "Not enough data to generate a credit score for:" },
                react_1.default.createElement(components_1.BusinessAddress, Object.assign({}, business)),
                react_1.default.createElement(NoReportText, null, bureauName !== null && bureauName !== void 0 ? bureauName : 'A bureau',
                    " has some data on your business, but not enough to generate a credit score yet. This could keep your business from qualifying for low-cost financing options."),
                !isDirect && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(NoReportText, null, "We\u2019ve made a simple, 3-step guide to help you establish a business credit score."),
                    react_1.default.createElement(InputWrapper, null,
                        react_1.default.createElement(base_react_components_1.Link, { href: businessMatchLink },
                            react_1.default.createElement(NotMyBusinessLink, null, "This is not my business")),
                        react_1.default.createElement(base_react_components_1.Link, { href: "/partner/education/tradeline" },
                            react_1.default.createElement(GetStartedLink, null, "Get started"))))))));
    }
    else if ((scoreDisplayProps === null || scoreDisplayProps === void 0 ? void 0 : scoreDisplayProps.riskCategory) === 'RecentBankruptcy') {
        return (react_1.default.createElement(exports.NoReportWrapper, { className: className },
            react_1.default.createElement(components_1.NeedMoreInfoWarning, { title: "This is complicated" },
                react_1.default.createElement(components_1.BusinessAddress, Object.assign({}, business)),
                react_1.default.createElement(NoReportText, null,
                    "A recent bankruptcy is showing on your ", bureauName !== null && bureauName !== void 0 ? bureauName : 'bureau',
                    " report, so we can\u2019t generate a score for you right now."),
                react_1.default.createElement(NoReportText, null, "If this is an error, you can dispute the inaccurate information with the bureaus. Read more in our article on business credit repair."),
                react_1.default.createElement(InputWrapper, null,
                    react_1.default.createElement(base_react_components_1.Link, { href: businessMatchLink },
                        react_1.default.createElement(NotMyBusinessLink, null, "This is not my business")),
                    !isDirect && (react_1.default.createElement(base_react_components_1.Link, { href: "/partner/education/tradeline" },
                        react_1.default.createElement(GetStartedLink, null, "Get started")))))));
    }
    return (react_1.default.createElement(components_1.ScoreDisplay, Object.assign({ "data-heap-redact-text": "true", bureau: bureau, className: `${className} js-private` }, scoreDisplayProps)));
};
exports.BasicScoreDisplay = BasicScoreDisplay;
exports.default = exports.BasicScoreDisplay;
//# sourceMappingURL=index.js.map